import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl, FormControlName } from '@angular/forms';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { WithSubscription } from '@shared/base';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[gccCkeditor]'
})
export class CkeditorDirective extends WithSubscription() implements OnInit, OnDestroy, AfterViewInit {
  @Input() public maxLength: number;

  get characters() {
    return this.charactersCount;
  }
  set characters(v: number) {
    this.charactersCount = v;
    this.updateCount();
  }

  get control() {
    return this.formControl || this.formControlName?.control;
  }

  private charactersCount: number;
  private charactersContainer: HTMLDivElement;
  constructor(
    private editor: CKEditorComponent,
    @Optional() private formControlName: FormControlName,
    @Optional() private formControl: FormControl,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }

  public ngOnInit() {
    if (this.maxLength) {
      this.patchValidators();
      this.subs.add(
        this.editor.ready
          .asObservable()
          .pipe(take(1))
          .subscribe(editor => {
            const wcPlugin: any = editor.plugins.get('WordCount');
            wcPlugin.on('update', (event, data: { characters: number }) => {
              this.characters = data.characters;
            });
            wcPlugin._refreshStats();
          })
      );
    }
  }

  public ngAfterViewInit() {
    this.renderCount();
  }

  public ngOnDestroy() {
    this.renderer.removeChild(this.el.nativeElement.parentElement, this.charactersContainer);
  }

  private renderCount() {
    this.charactersContainer = this.renderer.createElement('div');
    this.renderer.setAttribute(this.charactersContainer, 'class', 'pt-1 mb-n5 caption text-gray text-right');
    this.renderer.insertBefore(
      this.el.nativeElement.parentElement,
      this.charactersContainer,
      this.el.nativeElement.nextSibling
    );
    this.updateCount();
  }

  private updateCount() {
    this.charactersContainer.innerText = `${this.characters} / ${this.maxLength} character limit`;
  }

  private patchValidators() {
    const newValidators = this.control?.validator
      ? [this.control.validator, maxLengthValidator(this.maxLength, () => this.characters)]
      : [maxLengthValidator(this.maxLength, () => this.characters)];
    this.control?.setValidators(newValidators);
  }
}

export function maxLengthValidator(maxLength: number, getLength: () => number) {
  return (control: AbstractControl) => {
    if (maxLength < getLength()) {
      return {
        maxLength: getLength()
      };
    }
  };
}
